import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { Modal } from "react-bootstrap";
import { Input, Label } from "reactstrap";
import Plusicon from "../../../../assets/icon/plusicon";
import DatePicker from "react-datepicker";
import Editicon from "../../../../assets/icon/editicon";
// import { Button } from "reactstrap";

import { Trash } from "react-feather";
import Trueicon from "../../../../assets/icon/trueicon";
import { ApiDelete, ApiPost, ApiPut } from "../../../../helpers/API/ApiData";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function AddPlatesMnageModel(props) {
  const {
    inputValue,
    setInputValue,
    handleChange,
    errors,
    setError,
    formType,
    handleAddNews,
    handleOnClose,
    id,
    handleGetAllPlates,
  } = props;
  const [inputErrors, setInputErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [plateData, setPlateData] = useState("");
  const [editedPlateData, setEditedPlateData] = useState({
    data: "",
    isEdit: false,
    id: null,
  });
  const [enableInputId, setEnableInputId] = useState(null);

  const handleDynamicInputChange = (index, event) => {
    if (editedPlateData?.isEdit) {
      setEditedPlateData({ ...editedPlateData, data: event.target.value });
    } else {
      setPlateData(event.target.value);
    }
    // const updatedInputs = [...inputValue?.authPlates];
    // updatedInputs[index].plateNumber = event.target.value;

    // const updatedErrors = { ...inputErrors };
    // if (event.target.value.trim() !== "") {
    //   delete updatedErrors[index];
    // }
    // setInputErrors(updatedErrors);
    // setInputValue({ ...inputValue, authPlates: updatedInputs });
  };

  const addNewInput = () => {
    // Check for empty inputs
    const newErrors = {};

    inputValue.authPlates.forEach((input, index) => {
      if (input.plateNumber.trim() === "") {
        newErrors[index] = "Bitte geben Sie hier die Kamera-ID ein";
      }
    });

    // If there are errors, set them and exit
    if (Object.keys(newErrors).length > 0) {
      setInputErrors(newErrors);
      return;
    }

    // Add a new dynamic input
    setInputValue((prevState) => ({
      ...prevState,
      authPlates: [
        ...prevState.authPlates,
        { id: Date.now(), plateNumber: "" },
      ],
    }));
  };

  const removeInput = (index) => {
    const updatedInputs = inputValue?.authPlates.filter((_, i) => i !== index);
    setInputValue({ ...inputValue, authPlates: updatedInputs });

    // Remove associated error if it exists
    const updatedErrors = { ...inputErrors };
    delete updatedErrors[index];
    setInputErrors(updatedErrors);
  };

  const handleAddPlate = async () => {
    if (!plateData?.trim()) {
      return toast.error("Please enter plate number");
    }

    setLoading(true);
    let body = {
      plateNumber: plateData,
      locationId: id,
    };
    try {
      const response = await ApiPost(`dahuaAuthPlates/createAuthPlates`, body);
      toast.success(response?.data?.messages);
      handleGetAllPlates();
      setPlateData("");
      setLoading(false);
    } catch (error) {
      toast.error(error);
      setLoading(false);
    }
  };

  const handleUpdatePlate = async () => {
    if (!editedPlateData?.data) return toast.error("Please enter plate number");
    setLoading(true);
    let body = {
      plateNumber: editedPlateData?.data,
      locationId: id,
    };
    try {
      const response = await ApiPut(
        `dahuaAuthPlates/updateAuthPlates?id=${editedPlateData?.id}`,
        body
      );
      toast.success(response?.data?.messages);
      handleGetAllPlates();
      setEditedPlateData({ data: "", isEdit: false, id: null });
      setEnableInputId(null);
      setLoading(false);
    } catch (error) {
      toast.error(error);
      setLoading(false);
    }
  };

  const handleDeleteNewsInfo = async (row) => {
    setLoading(true);
    let response = false;
    await ApiDelete(`dahuaAuthPlates/deleteAuthPlates?id=${row?._id}`)
      .then((res) => {
        toast.success(res?.data?.messages);
        handleGetAllPlates();
        setLoading(false);
        response = true;
      })
      .catch((err) => {
        setLoading(false);
      });
    return response;
  };

  const handleDeletePlate = (row) => {
    if (!editedPlateData?.isEdit) {
      return Swal.fire({
        title: "Bist du sicher?",
        text: "Sind Sie sicher, dass Sie dieses Kennzeichen löschen möchten?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ja, löschen",
        cancelButtonText: "Abbrechen",
        customClass: {
          confirmButton: "btn btn-primary mr-10",
          cancelButton: "btn btn-danger ms-1",
        },
        buttonsStyling: false,
      }).then(async function (result) {
        if (result.value) {
          const res = await handleDeleteNewsInfo(row);
          if (res) {
            Swal.fire({
              icon: "success",
              title: "Gelöscht!",
              text: "Dieses Nummernschild wurde gelöscht.",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          } else {
            Swal.fire({
              title: "Abgesagt",
              text: "Löschung abgebrochen!!",
              icon: "error",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire({
            title: "Abgesagt",
            text: "Löschung abgebrochen!!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else {
          Swal.fire({
            title: "Abgesagt",
            text: "Löschung abgebrochen!!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    }
  };

  const handleStartDateChange = (index, date) => {
    const updatedInputs = [...inputValue.authPlates];
    updatedInputs[index].startDate = date;
    setInputValue({ ...inputValue, authPlates: updatedInputs });
  };

  const handleEndDateChange = (index, date) => {
    const updatedInputs = [...inputValue.authPlates];
    updatedInputs[index].endDate = date;
    setInputValue({ ...inputValue, authPlates: updatedInputs });
  };

  return (
    <div
      className="modal-content new-model-conent-sye"
      style={{ maxHeight: "600px", overflow: "auto" }}
    >
      <Modal.Header
        className="justify-content-start d-flex align-items-center"
        closeButton
      >
        <Modal.Title style={{ color: "#D7365A" }}>
          Kennzeichen verwalten{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: "auto" }}>
        <div className="dynamic-inputs">
          <Label className="form-label">Nummernschilder</Label>
          {inputValue?.authPlates?.map((input, index) => (
            <div key={input.id}>
              <div className="d-flex align-items-center mb-2">
                <Input
                  placeholder={`Kennzeichen ${index + 1}`}
                  value={
                    enableInputId === index &&
                    index != inputValue?.authPlates?.length - 1
                      ? editedPlateData?.data
                      : input?.plateNumber
                      ? input?.plateNumber
                      : plateData
                  }
                  disabled={
                    enableInputId === index
                      ? false
                      : index === inputValue?.authPlates?.length - 1 &&
                        !enableInputId
                      ? false
                      : true
                  }
                  onChange={(event) => handleDynamicInputChange(index, event)}
                  invalid={!!inputErrors[index]}
                />

                {/* <DatePicker
        selected={input.startDate || null}
        onChange={(date) => handleStartDateChange(index, date)}
        showTimeSelect
        dateFormat="Pp"
        disabled={enableInputId === index ? false : index === inputValue?.authPlates?.length - 1 && !enableInputId ? false : true}

        timeFormat="HH:mm"
      /> */}

                {/* <DatePicker

        disabled={enableInputId === index ? false : index === inputValue?.authPlates?.length - 1 && !enableInputId ? false : true}
        selected={input.endDate || null}
        onChange={(date) => handleEndDateChange(index, date)}
        showTimeSelect
        dateFormat="Pp"
        timeFormat="HH:mm"
        minDate={input.startDate}
      /> */}
                {/* <Button variant="outlined" color="secondary" onClick={() => removeInput(index)} style={{ marginLeft: "10px" }} disabled={inputValue?.authPlates.length === 1}>
                  Entfernen
                </Button> */}

                {/* {index === inputValue?.authPlates?.length - 1 && !input.plateNumber && (
                  <div className="plusicondiv" onClick={addNewInput}>
                    <Plusicon />
                  </div>
                )} */}

                {index === inputValue?.authPlates?.length - 1 &&
                  !enableInputId &&
                  plateData && (
                    <div
                      className="trueicondiv"
                      onClick={() => handleAddPlate()}
                    >
                      {/* <Trueicon /> */}
                      Speichern
                    </div>
                  )}

                {index != inputValue?.authPlates?.length - 1 &&
                  (enableInputId === index ? (
                    <div
                      className="trueicondiv"
                      onClick={() => handleUpdatePlate()}
                    >
                      {/* <Trueicon /> */}
                      Speichern
                    </div>
                  ) : (
                    <div className="modaleditanddelete">
                      <div
                        className="editicondiv"
                        onClick={() => {
                          setEnableInputId(index);
                          setEditedPlateData({
                            isEdit: true,
                            data: input?.plateNumber,
                            id: input?._id,
                          });
                        }}
                      >
                        <Editicon />
                      </div>
                      {inputValue?.authPlates?.length > 1 && (
                        <div
                          className="deleteicondiv"
                          onClick={() => handleDeletePlate(input)}
                        >
                          <Trash className="font-medium-2" />
                        </div>
                      )}
                    </div>
                  ))}
              </div>
              {inputErrors[index] && (
                <span className="errors text-danger ml-2">
                  {inputErrors[index]}
                </span>
              )}
            </div>
          ))}
          {/* <Button variant="outlined" color="primary" onClick={addNewInput} style={{ marginTop: "10px" }}>
            Hinzufügen
          </Button> */}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="activebutton h-40px"
          onClick={handleOnClose}
          style={{ marginRight: "15px" }}
        >
          Schließen
        </Button>
        {/* <Button disabled={loading} className="addbutton" onClick={handleAddNews}>
          <span>{formType == "add" ? " Speichern" : "aktualisieren"}</span>
          {loading && <div class="h-20px spinner-border text-light w-20px ml-2"></div>}
        </Button> */}
      </Modal.Footer>
    </div>
  );
}

export default AddPlatesMnageModel;
